import { useMutation } from "react-query";
import { usePopup } from "../../common/contexts/PopupContext";
import { useNavigate } from "react-router-dom";

import ResetPasswordForm from "../components/ResetPasswordForm";
import useSignup from "../../common/hooks/pages/useSignup";

function ResetPasswordContainer() {
  const navigate = useNavigate();

  const { toast } = usePopup();

  const { resetPassword } = useSignup();

  const { mutate: passwordReset, isLoading } = useMutation({
    mutationFn: resetPassword,
    onSuccess: (res) => {
      const { message } = res?.data;
      toast(message, "success");
      navigate("/profile");
    },
    onError: (error) => {
      const message =
        error?.response?.data?.message ||
        "Something went wrong while resetting password!";
      toast(message, "error");
    },
  });

  return (
    <div>
      <ResetPasswordForm
        onSubmit={(data) => passwordReset(data)}
        isSubmitting={isLoading}
      />
    </div>
  );
}

export default ResetPasswordContainer;
